<template>
  <section>
    <LogoHeader :shopCode="getShopCode" />

    <article v-if="getProducts.length > 0">
      <section class="">
        <div
          v-for="(prodByDept, index) in getProducts"
          :key="index"
          class="col-xs-3"
        >
          <h1 class="menu-name">{{ prodByDept.name }}</h1>

          <div
            v-for="(product, index) in prodByDept.products"
            :key="index"
            class="col-xs-3"
          >
            <ProductItem :product="product" />
          </div>
        </div>

        <br />
      </section>
    </article>

    <article v-else-if="loaded" class="menuError">
      <h4>No hay productos disponibles</h4>
    </article>
  </section>
</template>

<script>
import { db } from "../plugins/firebase";
import mobile_detection from "../mixins/mobile_detection";
import CartMixin from "../mixins/Cart_Mixin";
import ProductItem from "../Components/ProductItem";
import LogoHeader from "../Components/LogoHeader";

export default {
  mixins: [mobile_detection, CartMixin],
  name: "foodMenu",
  data() {
    return {
      shopCode: 0,
      origin: "",
      idList: -1,
      webOrderShopImageUrl: "",
      productsByDepartment: [],
      quantityProds: 0,
      loaded: false,
    };
  },
  mounted() {
    this.shopCode = this.$route.query.c;
    this.origin = this.$route.query.o;

    if (this.shopCode === "999991" && this.origin === "Mostrador") {
      window.location.href =
        "https://instagram.com/domauruguay?utm_medium=copy_link";
    } else {
      this.loadProductList(this.shopCode, this.origin);
    }
  },
  watch: {},
  computed: {
    getShopCode() {
      return this.shopCode;
    },
    getBistroWebordersBody() {
      if (this.isMobile()) {
        return "bistro-weborders-body-mobile";
      } else {
        return "bistro-weborders-body";
      }
    },
  },
  methods: {
    getListByShops() {
      const t = this;
      db.ref("products/" + this.shopCode)
        .once("value")
        .then(function (snapshot) {
          var res = snapshot.val();
          if (res.idList != null) {
            t.idList = res.idList;
            t.webOrderShopImageUrl = res.webOrderShopImageUrl;
          }
        });
    },
  },
  components: {
    ProductItem,
    LogoHeader,
  },
  middleware: ["noAuth"],
};
</script>

<style scoped>
.menu-name {
  font-size: 2em;
}
h1,
h2 {
  font-weight: normal;
}
p {
  font-weight: lighter;
  font-size: 0.8em;
  margin: 0em !important;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.bwo-title-inline {
  display: inline;
}

.bwo-menu-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.item-content {
  margin: 20px 0px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/FoodMenu.vue